﻿import api from '../api';
import { TipoPergunta } from './Pergunta';

const controller = 'questionarioMinuta';

export interface IPerguntaRespostaSelecionadas {
  id: string;
  respostas?: string[];
  isDeAcordo?: string;
  comentario?: string;
  observacaoDemandante?: string;
  necessitaObservacaoDemandante?: string;
}

export interface PerguntaQuestionarioMinuta {
  descricaoComOrdem: string;
  id: string;
  pergunta: string;
  tipoPergunta: TipoPergunta;
  tipoPerguntaId: string;
  respostas: RespostaQuestionarioMinuta[];
  ordenacao: number | string;
  necessitaConfirmacaoDemandante: boolean;
  necessitaObservacaoDemandante: string;
  isDeAcordo?: string;
  comentario?: string;
  tituloPerguntaQuestionario?: string;
  tiposMinutaConfirmacaoDemandante?: string[];
}

export interface RespostaQuestionarioMinuta {
  editavel: boolean;
  id: string;
  descricao: string;
  perguntaId: string;
  ordem: string | number;
  marcada: boolean;
}

export const getAllPerguntaQuestionarioMinuta = (demandaId: string) =>
  api.get<PerguntaQuestionarioMinuta[]>(`${controller}/perguntas/${demandaId}`);

export interface IQuestionarioMinuta {
  demandaId: string;
  perguntas: IPerguntaRespostaSelecionadas[];
}

export const postQuestionarioMinuta = (values: IQuestionarioMinuta) => {
  return api.post<any>(controller, values);
};

export const postCriarMinuta = (values: IQuestionarioMinuta) => {
  return api.post<any>(`${controller}/minutas`, values);
};

export const postDevolverQuestionarioMinuta = (values: IQuestionarioMinuta) => {
  return api.post<any>(`${controller}/devolver`, values);
};
